"use strict";

/*
 ## External Dependencies ##
 - jQuery ($)
 */

var ReactCSSTransitionGroup = React.addons.CSSTransitionGroup;
var Reflux = require("reflux");
var ReactIntl = require("react-intl");
var ActivitiesListingActions = require("app/screens/Activity/actions/activities-listing-actions");
var ActivitiesListingStore = require("app/screens/Activity/stores/activities-listing-store");
var Activity = require("./activity.jsx");
var ListingLoader = require("app/shared/components/List/listing-loader");
var ButtonPrimary = require("app/shared/components/Button/button-primary");
var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");
var ActivityInput = require("../ActivityInput/activity-input");
var EmptyList = require("app/shared/components/List/empty-list");

var _ = require("underscore");
var moment = require("moment");
moment.locale("pt-br");

var PAGINATION_SIZE = 10;

var ActivitiesListing = React.createClass({
  mixins: [Reflux.ListenerMixin, ReactIntl.IntlMixin],
  propTypes: {
    filters: React.PropTypes.object,
    activities: React.PropTypes.object,
    loading: React.PropTypes.object,
    updateTotalActivitiesCount: React.PropTypes.func,
    filters: React.PropTypes.object
  },
  getInitialState: function () {
    var defaultData = ActivitiesListingStore.getDefaultData();
    _.extend(defaultData.filters, this.props.filters);
    if (this.props.activities) {
      defaultData.activities = this.props.activities;
    }
    if (this.props.loading !== undefined) {
      defaultData.loading = this.props.loading;
    }
    return defaultData;
  },
  componentDidMount: function() {
    this.listenTo(ActivitiesListingStore, this.setState);

    window.addEventListener("scroll", this.handleScroll);
  },
  componentWillUnmount: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
  hasMorePages: function () {
    return this.state.activities.length < parseInt(this.state.totalResults);
  },
  handleScroll: function () {
    if (this.shouldGetMoreActivities()) {
      window.removeEventListener("scroll", this.handleScroll);

      this.state.filters.offset += PAGINATION_SIZE;
      ActivitiesListingActions.getMoreActivities(this.state.filters, true);
    }
  },
  shouldGetMoreActivities: function() {
    var isLoading = (this.state.loading || this.state.loadingMore);

    return (!isLoading
      && (this.getScrollBottomDistance() < 250)
      && this.hasMorePages());
  },
  getScrollBottomDistance: function() {
    var element = ReactDOM.findDOMNode(this);
    var scrollTop = (window.pageYOffset !== undefined)
      ? window.pageYOffset
      : (document.documentElement || document.body.parentNode || document.body).scrollTop;

    return (topPosition(element)
      + element.offsetHeight
      - scrollTop
      - window.innerHeight);
  },
  componentDidUpdate: function (prevProps, prevState) {
    if (this.state.loadingMore == false) {
      // just attach the handle back after the previous loading is done
      window.addEventListener("scroll", this.handleScroll);
    }
    if (prevState.totalResults != this.state.totalResults && this.props.updateTotalActivitiesCount) {
      this.props.updateTotalActivitiesCount(this.state.totalResults);
    }
  },
  update3rdParties: function () {
    if (typeof $ == "function" && typeof document == "object") {
      $(document).trigger("ActivitiesListing.rendered", {total: this.state.totalResults});
      //Listened by agendor-web - Comentario.js
    }
  },
  getErrorMessage: function() {
    if (this.state.failedWithCustomError) {
      if (this.state.failedWithClientSideError) {
        return this.getIntlMessage("activities.request_error_message.client_side");
      } else {
        return this.getIntlMessage("activities.request_error_message.server_side.full");
      }
    } else {
      return this.getIntlMessage("activities.request_error_message.generic");
    }
  },
  retryLoad: function() {
    ActivitiesListingActions.retryGetActivities(this.state.filters);
  },
  render: function() {
    var activities = [];
    for (var key in this.state.activities) {
      var activity = this.state.activities[key];
      if(activity.editing){
        activities.push(<ActivityInput instanceKey={activity.instanceKey} editing={true} key={activity.id} />);
      } else {
        activities.push(<Activity {...activity} filters={this.state.filters} key={activity.id} />);
      }
    }

    this.update3rdParties();

    if (this.state.loading || this.state.activities.length > 0) {
      return (
        <div className="activitiesListing">
          <ListingLoader
            visible={this.state.loading}
            position="over"/>
          {activities}
          <ListingLoader
            visible={this.state.loadingMore && !this.state.failed}
            position="below"/>
        </div>
      );
    } else if (this.state.failed || this.state.retryButtonPressed) {
      return (
        <FailedToLoadActivitiesListing
          message={this.getErrorMessage()}
          retryLoad={this.retryLoad}
          retryButtonPressed={this.state.retryButtonPressed} />
      );
    } else {
      return (
        <EmptyActivitiesListing
          {...this.props}
          filters={this.state.filters} />
      );
    }
  }
});

var EmptyActivitiesListing = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  render: function render() {
    if (this.props.env == "activities") {
      return (<EmptyActivitiesListMessage {...this.props}/>);
    } else if (this.props.env == "task") {
      return (<EmptyTasksListMessage {...this.props}/>);
    } else if (this.props.env == "deal") {
      return (<EmptyDealHistoryMessage {...this.props}/>);
    } else {
      return (<EmptyEntityHistoryMessage {...this.props}/>);
    }
  }
});

var EmptyActivitiesListMessage = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  render: function () {
    var props = {
      title: this.getIntlMessage("activities.empty_list.title"),
      subtitle: this.getIntlMessage("activities.empty_list.subtitle")
    };
    return (
      <EmptyList {...props} >
        <ButtonPrimary classes="btnAdicionarTarefa ta-c" id="btnAdicionarTarefa"
                     href="/sistema/tarefas/?addActivity=1" text="Adicionar tarefa"/>
      </EmptyList>
    );
  }
});

var EmptyTasksListMessage = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  getTitle: function () {
    var message;
    if (this.hasFiltersDefined()) {
      if (this.props.filters.pending) {
        message = this.getIntlMessage("tasks.empty_list.pending");
      } else {
        message = this.getIntlMessage("tasks.empty_list.done");
      }
    } else {
      message = this.getIntlMessage("activities.empty_list.title");
    }
    var metricsCount = 0;
    if (this.props.filters.metric_ids) {
      metricsCount = this.props.filters.metric_ids.length;
    }

    return this.formatMessage(message, {
      pending : this.props.filters.pending,
      metricsCount : metricsCount,
      metricsNames : stringifyArray(this.props.filters.metric_names, " ou ").toLowerCase(),
      username : this.props.filters.userName,
      hasUser : this.props.filters.userName != null,
      dateRange : this.props.filters.dateRange,
      dtInicial : moment(this.props.filters.dtInicial).format("LL"),
      dtFinal : moment(this.props.filters.dtFinal).format("LL"),
      filters : this.props.filters,
      filtersCount : this.props.filters.length
    });
  },
  getSubtitle: function () {
    var emptySubtitle = "";
    if (!this.hasFiltersDefined()) {
      emptySubtitle = this.getIntlMessage("activities.empty_list.subtitle");
    }
    return emptySubtitle;
  },
  hasFiltersDefined: function () {
    return this.props.filters.userName || this.props.filters.dateRange != "ALL"
      || (this.props.filters.metric_ids && this.props.filters.metric_ids.length > 0);
  },
  render: function () {
    var props = {
      title: this.getTitle(),
      subtitle: this.getSubtitle()
    };
    return (<EmptyList {...props} />);
  }
});

var EmptyEntityHistoryMessage = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  render: function () {
    var props = {
      title: this.getIntlMessage("entity.empty_history.title"),
      subtitle: this.getIntlMessage("entity.empty_history.subtitle")
    };
    return (<EmptyList {...props} />);
  }
});

var EmptyDealHistoryMessage = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  render: function () {
    var props = {
      title: this.getIntlMessage("deal.empty_history.title"),
      subtitle: this.getIntlMessage("deal.empty_history.subtitle")
    };
    return (<EmptyList {...props} />);
  }
});

var FailedToLoadActivitiesListing = React.createClass({
  render: function() {
    return (
      <div className="activitiesListing--empty w-100 ta-c">
        <h2 className="fst-i c-lightGrey"
          dangerouslySetInnerHTML={{ __html: this.props.message}}>
        </h2>

        <Button type="primary"
          className="ta-c mh-36"
          onClick={this.props.retryLoad}
          disabled={this.props.retryButtonPressed}>
          <span className="flex-center-all">
            <Icon icon="repeat"/>
            <span className="ml-10 fw-300 fs-15">Tentar novamente</span>
          </span>
        </Button>
      </div>
    );
  }
});

/*
 * Recursive function used by Infity Scroll logic to calculate position from top of an element.
 */
function topPosition(domElt) {
  if (!domElt) {
    return 0;
  }
  return domElt.offsetTop + topPosition(domElt.offsetParent);
}

function stringifyArray(values, separator) {
  separator = separator || " e ";
  values = values || [];
  var length = values.length;
  if (length < 2) {
    return values.join("");
  } else if (length == 2) {
    return values.join(separator);
  } else {
    var commaSeparated = values.slice(0, -1).join(", ");
    var lastValue = values.slice(-1).join("");
    return commaSeparated + separator + lastValue;
  }
}

module.exports = ActivitiesListing;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityList/activities-listing.jsx